// extracted by mini-css-extract-plugin
export var exploreCoursesButton = "IntenshipAddToCartButton-module--exploreCoursesButton--11195";
export var exploreCoursesText = "IntenshipAddToCartButton-module--exploreCoursesText--cc962";
export var lmsScrollbar = "IntenshipAddToCartButton-module--lms-scrollbar--fe0ba";